var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 373,
    height: 122,
    viewBox: "0 0 373 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 74.7107L15.9521 83.3326L51.2477 62.856L35.756 54.2341L1 74.7107Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08594 95.7768L16.038 104.399L51.3336 83.9221L35.8419 75.3027L1.08594 95.7768Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9512 83.3323V104.399",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9629 62.6624V83.7313",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 74.5598V96.1734",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9531 83.1392L30.9077 91.761L66.2008 71.2845L50.7091 62.6626L15.9531 83.1392Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0391 104.208L30.9936 112.827L66.2868 92.3533L50.795 83.7314L16.0391 104.208Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9082 91.761V112.827",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65.916 71.0911V92.16",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9531 82.9912V104.602",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1 53.6441L15.9521 62.2634L51.2477 41.7893L35.756 33.1675L1 53.6441Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08594 74.7107L16.038 83.3326L51.3336 62.856L35.8419 54.2341L1.08594 74.7107Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9512 62.2634V83.3324",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9629 41.5959V62.6624",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1 53.4934V75.107",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0371 62.0725L30.9917 70.6944L66.2848 50.2178L50.7931 41.5959L16.0371 62.0725Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.123 83.1389L31.0751 91.7608L66.3707 71.2842L50.879 62.6624L16.123 83.1389Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9922 70.6946V91.761",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50.0244V71.0908",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0371 61.9216V83.5353",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0059 91.7505L45.9604 100.372L81.2536 79.8958L65.7618 71.2739L31.0059 91.7505Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0918 112.817L46.0464 121.439L81.3395 100.962L65.8478 92.3406L31.0918 112.817Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9609 100.373V121.439",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9707 79.7026V100.769",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0059 91.5999V113.213",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0957 70.6819L46.0503 79.3038L81.3434 58.8272L65.8517 50.2053L31.0957 70.6819Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1816 91.7508L46.1362 100.37L81.4293 79.896L65.9376 71.2742L31.1816 91.7508Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0508 79.3037V100.373",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0586 58.6367V79.7032",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0957 70.5337V92.1473",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1 32.648L15.9521 41.2698L51.2477 20.7932L35.756 12.1714L1 32.648Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1.08594 53.7143L16.038 62.3362L51.3336 41.8596L35.8419 33.2402L1.08594 53.7143Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9512 41.2695V62.336",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9629 20.5999V41.6688",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1 32.4973V54.1109",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0371 41.0764L30.9917 49.6983L66.2848 29.2217L50.7931 20.5999L16.0371 41.0764Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M16.123 62.1425L31.0751 70.7644L66.3707 50.2903L50.879 41.6685L16.123 62.1425Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9922 49.6982V70.7647",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29.0286V50.0975",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0371 40.9255V62.5391",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0957 49.6887L46.0503 58.3081L81.3434 37.834L65.8517 29.2122L31.0957 49.6887Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1816 70.7554L46.1362 79.3772L81.4293 58.9007L65.9376 50.2788L31.1816 70.7554Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0508 58.3081V79.377",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0586 37.6406V58.7071",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0957 49.5381V71.1517",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M248.252 83.1392L263.204 91.761L298.497 71.2845L283.005 62.6626L248.252 83.1392Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M248.334 104.208L263.289 112.827L298.582 92.3533L283.09 83.7314L248.334 104.208Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M263.203 91.761V112.827",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M298.215 71.0911V92.16",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M248.252 82.9915V104.603",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M233.297 53.6441L248.251 62.2634L283.545 41.7893L268.053 33.1675L233.297 53.6441Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M233.383 74.7107L248.335 83.3326L283.63 62.856L268.139 54.2341L233.383 74.7107Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M248.252 62.2634V83.3324",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M283.26 41.5959V62.6624",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M233.297 53.4934V75.107",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M248.336 62.0723L263.291 70.6941L298.584 50.2176L283.092 41.5957L248.336 62.0723Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M248.422 83.1389L263.376 91.7608L298.67 71.2842L283.178 62.6624L248.422 83.1389Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M263.291 70.6941V91.7605",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M298.299 50.0242V71.0906",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M248.336 61.9216V83.5353",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M351.494 21.669L336.542 30.2908L301.246 9.81424L316.738 1.19238L351.494 21.669Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M351.408 42.7356L336.456 51.3575L301.16 30.8809L316.652 22.259L351.408 42.7356Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M336.541 30.2908V51.3572",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M301.529 9.62085V30.6898",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M351.494 21.5183V43.1319",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M321.27 63.7315L336.222 72.3533L371.517 51.8767L356.026 43.2549L321.27 63.7315Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M321.355 84.7981L336.308 93.42L371.603 72.9434L356.111 64.3215L321.355 84.7981Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M336.221 72.3533V93.4197",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M371.232 51.6833V72.7523",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M321.27 63.5808V85.1944",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M233.297 32.6485L248.251 41.2703L283.545 20.7937L268.053 12.1719L233.297 32.6485Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M233.383 53.7148L248.335 62.3366L283.63 41.8601L268.139 33.2407L233.383 53.7148Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M248.252 41.2703V62.3367",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M283.26 20.6003V41.6693",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M233.297 32.4978V54.1114",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M266.338 30.5424L281.29 39.1643L316.586 18.6877L301.094 10.0684L266.338 30.5424Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M266.424 51.6116L281.376 60.2334L316.672 39.7569L301.18 31.135L266.424 51.6116Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M281.289 39.1643V60.2332",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M316.301 18.4968V39.5633",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M266.338 30.3943V52.0079",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M321.27 42.7359L336.222 51.3577L371.517 30.8811L356.026 22.2593L321.27 42.7359Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M321.355 63.8047L336.308 72.424L371.603 51.95L356.111 43.3281L321.355 63.8047Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M336.221 51.3574V72.4239",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M371.232 30.6877V51.7567",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M321.27 42.5876V64.1987",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M110.043 74.7105L124.995 83.3323L160.291 62.8557L144.799 54.2339L110.043 74.7105Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M110.129 95.7768L125.081 104.399L160.377 83.9221L144.885 75.3027L110.129 95.7768Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M124.994 83.3323V104.399",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M160.006 62.6624V83.7313",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M110.043 74.5598V96.1734",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M124.996 83.1392L139.951 91.761L175.244 71.2845L159.752 62.6626L124.996 83.1392Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M125.082 104.208L140.034 112.827L175.33 92.3533L159.838 83.7314L125.082 104.208Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M139.951 91.761V112.827",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M174.959 71.0911V92.16",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M124.996 82.9915V104.603",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M110.043 53.6441L124.995 62.2634L160.291 41.7893L144.799 33.1675L110.043 53.6441Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M110.129 74.7102L125.081 83.3321L160.377 62.8555L144.885 54.2336L110.129 74.7102Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M124.994 62.2632V83.3321",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M160.006 41.5959V62.6624",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M110.043 53.4934V75.107",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M140.223 53.3203L155.177 61.9422L190.47 41.4656L174.979 32.8438L140.223 53.3203Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M140.309 74.387L155.261 83.0088L190.556 62.5323L175.065 53.9104L140.309 74.387Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M155.178 61.9421V83.0086",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M190.186 41.2722V62.3412",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M140.223 53.1697V74.7833",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M140.051 91.751L155.005 100.373L190.298 79.8963L174.807 71.2744L140.051 91.751Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M140.137 112.818L155.091 121.44L190.384 100.963L174.893 92.3411L140.137 112.818Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M155.006 100.373V121.439",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M190.014 79.7029V100.769",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M140.051 91.6003V113.214",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M155.277 61.9297L170.232 70.5516L205.525 50.075L190.033 41.4531L155.277 61.9297Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M155.363 82.9986L170.318 91.6179L205.611 71.1438L190.119 62.522L155.363 82.9986Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M170.232 70.5518V91.6207",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M205.24 49.8845V70.951",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M155.277 61.782V83.3956",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M110.043 32.6485L124.995 41.2703L160.291 20.7937L144.799 12.1719L110.043 32.6485Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M110.129 53.7148L125.081 62.3366L160.377 41.8601L144.885 33.2407L110.129 53.7148Z",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M124.994 41.2703V62.3367",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M160.006 20.6003V41.6693",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M110.043 32.4978V54.1114",
    stroke: "white",
    strokeWidth: 0.46937,
    strokeMiterlimit: 10
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M140.223 32.3242L155.177 40.9461L190.47 20.4695L174.979 11.8477L140.223 32.3242Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M140.309 53.3906L155.261 62.0124L190.556 41.5384L175.065 32.9165L140.309 53.3906Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M155.178 40.946V62.0125",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M190.186 20.2761V41.3451",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M140.223 32.1736V53.7872",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M155.277 40.9361L170.232 49.5554L205.525 29.0813L190.033 20.4595L155.277 40.9361Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M155.363 62.0027L170.318 70.6246L205.611 50.148L190.119 41.5261L155.363 62.0027Z",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M170.232 49.5554V70.6244",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M205.24 28.8879V49.9544",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M155.277 40.7854V62.399",
    stroke: "#26483E",
    strokeWidth: 0.81575,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.af1c0f2541d7aea11a69852547d44e0b.svg";
export { ForwardRef as ReactComponent };